var $ = jQuery;

import Swiper from 'swiper';
import { Mousewheel, Autoplay } from 'swiper/modules';
Swiper.use([Mousewheel, Autoplay]);

$(document).on('ready', function(){
    if($('.customer-swiper').length){
      $('.customer-swiper').each(function(index){
          new Swiper($(this)[0], {
          slidesPerView: 2.5,
          direction: "vertical",
          mousewheelControl: true,
          mousewheel: {
            invert: false,
            releaseOnEdges: true,
          },
          loop: true,
          spaceBetween: 20,
          slidesOffsetAfter: 48,
          autoplay: {
            delay: 4000,
          },
          breakpoints: {
            300: {
              slidesPerView: 1.1,
              speed:800,
              direction: "horizontal",
              autoHeight: false,
            },
            500: {
              slidesPerView: 2,
              speed:800,
              direction: "horizontal",    
              autoHeight: false,
           },
            1024: {
              slidesPerView: 'auto',
              direction: "vertical", 
              autoHeight: true,
            },
          },
        });
      });
    }
  });
